import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["search", "results", "tags"];

  search(event) {
    const query = event.target.value.toLowerCase();
    const tags = this.tagsTarget.querySelectorAll("label");

    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    const matches = Array.from(tags).filter((tag) =>
      tag.textContent.toLowerCase().includes(query)
    );

    if (matches.length > 0) {
      this.resultsTarget.innerHTML = matches
        .map(
          (tag) => `
        <div class="px-3 py-2 hover:bg-slate-50 dark:hover:bg-slate-600 cursor-pointer"
             data-action="click->provider-tags#select"
             data-provider-id="${tag.dataset.providerId}">
          ${tag.innerHTML}
        </div>
      `
        )
        .join("");
      this.resultsTarget.classList.remove("hidden");
    } else {
      this.resultsTarget.classList.add("hidden");
    }
  }

  select(event) {
    const providerId = event.currentTarget.dataset.providerId;
    const checkbox = this.tagsTarget.querySelector(
      `[data-provider-id="${providerId}"] input`
    );
    checkbox.checked = !checkbox.checked;
    this.resultsTarget.classList.add("hidden");
    this.searchTarget.value = "";
  }
}
